<template>
    <div>
        <b-card>
            <b-card-body class="inventory_transfer p-0 mt-3">
                <b-col cols="12" class="dd">
                    <b-form-select v-model="selectedmasterItemId" class="form-control" :options="selectedMasterItems" text-field="name"
                        value-field="id">
                        <template #first>
                            <b-form-select-option disabled :value="null">
                                {{ $translate('view_recent_transactions') }}
                            </b-form-select-option>
                        </template></b-form-select>
                </b-col>
                <b-col class="d-flex justify-content-end">
                    <button class="btn blue-button mt-2" @click="cancel">
                        {{ $cancelLabel() }}
                    </button>
                </b-col>


                <ItemTransactions v-if="!!selectedmasterItemId" :total-qty="totalQty" :inventory-list="inventoryList"
                    :tableLoading="tableLoading" />
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ItemTransactions from '../../components/ItemTransactions.vue'
export default {
    components: { ItemTransactions },
    props: ['title', 'transferItems'],
    data() {
        return {
            selectedmasterItemId: null,
            tableLoading: false,
        }
    },
    computed: {
        totalQty() {
            const { selectedmasterItemId } = this
            if (selectedmasterItemId == null) return 0
            const item = this.selectedMasterItems.find(
                x => x.id === selectedmasterItemId
            )
            return item.section.quantity_on_hand
        },
        inventoryList() {
            return this.$store.getters['masterItem/sections'].filter(
                ({ location_section: x }) =>
                    x.officers.length || x.location.is_warehouse
            )
        },
        selectedMasterItems() {
            const _selectedMasterItems = []
            for (const item of this.transferItems) {
                const idx = _selectedMasterItems.findIndex(x => x.id == item.id)
                if (idx == -1) {
                    const pItem = { ...item }
                    pItem.section = {}
                    pItem.section.quantity_on_hand =
                        item.section.quantity_on_hand
                    _selectedMasterItems.push(pItem)
                } else {
                    const pItem = _selectedMasterItems[idx]
                    pItem.section.quantity_on_hand +=
                        item.section.quantity_on_hand
                    this.$set(_selectedMasterItems, idx, pItem)
                }
            }
            console.log('_selectedMasterItems', _selectedMasterItems)
            return _selectedMasterItems
        },
    },
    watch: {
        selectedmasterItemId: async function (id) {
            try {
                this.tableLoading = true
                await this.$store.dispatch('masterItem/fetchById', id)
            } catch (err) {
                console.log('selectedmasterItemId:', err)
            } finally {
                this.tableLoading = false
            }
        },

        selectedMasterItems: {
            handler: function () {
                console.log('bingo again')
                this.$nextTick(() => {
                    if (this.selectedMasterItems.length === 1) {
                        this.selectedmasterItemId =
                            this.selectedMasterItems[0].id
                    }
                    console.log(
                        'watched selectedmasterItemId',
                        this.selectedmasterItemId
                    )
                })
            },
            deep: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.selectedMasterItems.length === 1) {
                this.selectedmasterItemId = this.selectedMasterItems[0].id
            }
            console.log(
                'mounted selectedmasterItemId',
                this.selectedmasterItemId
            )
        })
    },
    methods: {
        cancel() {
            this.$store.commit('masterItem/SET_TRANSFER_ITEMS', [])
        },
    },
}
</script>

<style></style>